import { useBuilderStore } from '../../store/builderStore';
import type { DesignNode } from '../../types/node.types';
import type { ValidationResult } from '../../lib/validation/types';

const statusConfig = {
  pass: { dot: 'bg-green-500', label: 'text-green-700' },
  warning: { dot: 'bg-amber-500', label: 'text-amber-700' },
  error: { dot: 'bg-red-500', label: 'text-red-700' },
} as const;

export const DpiIndicator = () => {
  const selectedNodeId = useBuilderStore((s) => s.selectedNodeId);
  const currentSurface = useBuilderStore((s) => s.currentSurface);
  const surfaces = useBuilderStore((s) => s.surfaces);
  const nodeValidation = useBuilderStore((s) => s.nodeValidation);

  if (!selectedNodeId) return null;

  const node = (surfaces[currentSurface] ?? []).find(
    (n: DesignNode) => n.id === selectedNodeId,
  );
  if (!node) return null;

  // SVGs are always high quality
  if (node.type === 'svg') {
    return (
      <div className="mt-2 flex items-center gap-1.5 rounded-full bg-gray-400 px-3 py-1 shadow-xs border border-gray-200 transition-opacity duration-200">
        <span className="h-1.5 w-1.5 rounded-full bg-green-500" />
        <span className="text-[11px] text-green-700">Vector — prints at any size</span>
      </div>
    );
  }

  // Only show for raster images
  if (node.type !== 'image') return null;

  const results: ValidationResult[] = nodeValidation[selectedNodeId] ?? [];
  const resolution = results.find((r) => r.key === 'resolution');

  if (!resolution) return null;

  const config = statusConfig[resolution.status];

  return (
    <div className="mt-2 flex items-center gap-1.5 rounded-full bg-white px-3 py-1 shadow-xs border border-gray-200 transition-opacity duration-200">
      <span className={`h-1.5 w-1.5 rounded-full ${config.dot}`} />
      <span className={`text-[11px] ${config.label}`}>{resolution.message}</span>
    </div>
  );
};
